import React from "react";
import TopHeader from "../components/TopHeader"; // Adjust the path based on your project structure
// import ReviewCarousel from "../components/reviewCarousel"; // Adjust the path based on your project structure
import LeftAuthLayout from "./leftAuthLayout";

const AuthLayout = ({ children,image,title }) => {

  return (
    <div className="auth-layout">
      <TopHeader btn={true}/>
      
      <div className="container-fluid auth-page ps-0 mx-0">
        <div className="row h-100">

          <LeftAuthLayout image={image} title={title} />
          <div className="col-lg-1"></div>
          <div className="col-lg-5">
                <div className="auth-right">
                    {children}
                </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
